package com.wintermar.inspection.feature.domain.model.template

data class InspectionPageModel(
    val id: String = "",
    val templateId: String = "",
    val order: Int = 0,
    val title: String = "",
    val sections: List<InspectionSectionModel> = listOf()
) {
    fun getTotalRequiredQuestions(): Int {
        return sections.sumOf { section ->
            section.questions.count { it.required }
        }
    }

    fun getTotalAnsweredRequiredQuestions(): Int {
        return sections.sumOf { section ->
            section.questions.count { it.required && it.answer.isAnswered(it.answerType) }
        }
    }
}
